'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.availableCurrenciesSelector = exports.activeCurrencySelector = exports.customerCurrencyCodeSelector = undefined;

var _CurrencyCodes = require('self-service-api/constants/CurrencyCodes');

var CurrencyCodes = _interopRequireWildcard(_CurrencyCodes);

var _availableCurrenciesAdapter = require('self-service-api/adapters/availableCurrenciesAdapter');

var _availableCurrenciesAdapter2 = _interopRequireDefault(_availableCurrenciesAdapter);

var _MerchandiseSelectors = require('pricing-pages-unified-ui/selectors/MerchandiseSelectors');

var _AuthAdminSelectors = require('pricing-pages-unified-ui/selectors/AuthAdminSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var customerCurrencyCodeSelector = exports.customerCurrencyCodeSelector = function customerCurrencyCodeSelector(_ref) {
  var customerCurrencyCode = _ref.customerCurrencyCode;
  return customerCurrencyCode;
};

var activeCurrencySelector = exports.activeCurrencySelector = function activeCurrencySelector(state) {
  var activeCurrencyCode = state.activeCurrencyCode;

  var customerCurrencyCode = customerCurrencyCodeSelector(state);

  if (customerCurrencyCode) {
    return customerCurrencyCode;
  }

  if (!CurrencyCodes[activeCurrencyCode]) return CurrencyCodes.USD;

  return activeCurrencyCode;
};

// TODO: With the new pricing page design, the concept of giving
// available currencies per merch is outdated.
// For now, we can hackily provide no merchandiseId, and get all CurrencyCodes back
// but this is worth reevaluating
var availableCurrenciesSelector = exports.availableCurrenciesSelector = function availableCurrenciesSelector(state, merchandiseId) {
  var merchandise = (0, _MerchandiseSelectors.merchandiseSelector)(state);
  var customerCurrencyCode = customerCurrencyCodeSelector(state);
  var authState = (0, _AuthAdminSelectors.authStateSelector)(state);

  if (!merchandise) return [];

  // This check is temporary. See https://git.hubteam.com/HubSpot/pricing-pages-unified-ui/pull/554
  if (customerCurrencyCode) return [customerCurrencyCode];

  if (!merchandiseId) return Object.values(CurrencyCodes || {});

  var productData = {
    products: merchandise,
    customerCurrencyCode: customerCurrencyCode,
    authState: authState
  };

  var availableCurrencies = (0, _availableCurrenciesAdapter2.default)(productData, {
    itemConfigurations: [{ merchandiseId: merchandiseId }]
  });

  return Object.keys(CurrencyCodes).filter(function (currency) {
    return availableCurrencies.includes(currency);
  });
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/CurrencySelectors.js
// module id = 37
// module chunks = 3 4 5